import {
  EntitySynchronizationInfo,
  GetActualizationEntityInfo,
  GetActualizationsResult,
  QueueItemType,
  EntityWithEntityName
} from '@record-it-npm/synchro-client';
import { GetActualizationsRequestDto } from 'record-it-time-common/dto/synchronization/GetActualizationsRequestDto';
import { GetActualizationsResponseDto } from 'record-it-time-common/dto/synchronization/GetActualizationsResponseDto';
import { UploadRequestDto } from 'record-it-time-common/dto/synchronization/UploadRequestDto';
import { UploadResponseDto } from 'record-it-time-common/dto/synchronization/UploadResponseDto';
import { EntityName } from 'record-it-time-common/EntityName';
import { HttpMethod } from 'record-it-time-common/enums/HttpMethod';
import { ApiRequester } from '../ApiRequester/ApiRequester';
import { AppEntityManagerEntityTypesByEntityName } from './AppEntityManagerEntityTypesByEntityName';
import { AppSynchronizationEnvironmentTypes } from '../../AppSynchronizationEnvironmentTypes';

export class AppEntityManagerApiAdapter {
  public async getActualizations(
    infos: Array<GetActualizationEntityInfo<AppSynchronizationEnvironmentTypes>>
  ): Promise<
    GetActualizationsResult<
      AppSynchronizationEnvironmentTypes,
      AppEntityManagerEntityTypesByEntityName
    >
  > {
    // eslint-disable-next-line no-console
    console.log('getting actualizations');

    const response = await ApiRequester.postJson<GetActualizationsResponseDto>(
      'synchronization/getActualizations',
      {
        body: {
          entityInfos: infos
        } as GetActualizationsRequestDto
      }
    );

    if (!response.success) {
      throw new Error(response.error);
    }

    return {
      entities: response.entities,
      missingEntityInfos: response.missingEntityInfos
    };
  }

  public async uploadFunction<TEntityName extends EntityName>(
    item: EntitySynchronizationInfo<
      AppSynchronizationEnvironmentTypes,
      TEntityName,
      AppEntityManagerEntityTypesByEntityName
    >
  ): Promise<
    EntityWithEntityName<
      AppSynchronizationEnvironmentTypes,
      TEntityName,
      AppEntityManagerEntityTypesByEntityName
    >
  > {
    // eslint-disable-next-line no-console
    console.log('[AppEntityManager] uploading item', item);

    let method;

    if (item.type === QueueItemType.PUT) {
      if (item.entity.onlyLocal) {
        method = HttpMethod.Post;
      } else {
        method = HttpMethod.Put;
      }
    } else {
      method = HttpMethod.Delete;
    }

    const response = await ApiRequester.fetchJson<
      UploadResponseDto<EntityName>
    >('synchronization/upload', {
      method,
      body: {
        entity: {
          ...item.entity,
          readyToSynchronize: undefined,
          onlyLocal: undefined,
          shadowEntity: undefined,
          temporaryGroupName: undefined
        },
        entityName: item.entityName
      } as UploadRequestDto<TEntityName>
    });

    if (!response.success) {
      throw new Error(
        `failed uploading entity, ${response.error}: ${response.message}`
      );
    }

    return {
      entity: {
        ...item.entity,
        ...response.entity,
        onlyLocal: false
      },
      entityName: response.entityName as any
    };
  }
}
